__webpack_require__.p = "/reborn-pokepedia/";